import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import VideoPlayer from '../../../commonComponents/fileViewers/VideoPlayer';
import ProductProp from '../propTypes/productProp';

function ShopProductImage({ selectedImage, product, showVideoFirst }) {
  const media = useMemo(
    () =>
      product?.teaserVideo && showVideoFirst
        ? [
            {
              ...product?.teaserVideo,
              isVideo: true,
              _id: product?.teaserVideo?.name,
            },
            ...(product.images || []),
          ]
        : product.images,
    [product?.teaserVideo, product.images],
  );
  const userSelected =
    selectedImage && media?.find(i => i._id === selectedImage);
  const image = userSelected || media?.[0];

  return (
    <>
      {!image?.isVideo && (
        <img src={image?.url || '/images/no_image_upload.png'} alt="" />
      )}

      {image?.isVideo && image?.url && (
        <VideoPlayer video={image} startPlaying />
      )}
    </>
  );
}

ShopProductImage.propTypes = {
  product: PropTypes.shape(ProductProp.propType).isRequired,
  selectedImage: PropTypes.string,
  showVideoFirst: PropTypes.bool,
};

ShopProductImage.defaultProps = {
  selectedImage: null,
  showVideoFirst: false,
};

export default translate(ShopProductImage);
